import axios from 'axios'

import { WISHLIST as ENDPOINT } from '../common/endpoints'
import { success, error } from './toast-notifications'
import { t } from './i18n'

const wishlistP = document.querySelector('.j-product-info__favourite')
const wishlistC = document.querySelectorAll('.j-card__favourite')

const addToWishlist = async (e) => {
	e.preventDefault()
	//console.debug(e)

 	try {
		// add to wishlist
		const res = await axios.post(ENDPOINT, {
			productId: e.currentTarget.dataset['id'],
			data: {
				lang: window.motostorm.lang
			}		
		})

		success(t('add-to-wishlist-success'))
	} catch (err) {
		console.log(err)
		if (err.response?.status === 401 && err.response?.data?.loginUrl) {
			window.location.assign(err.response.data.loginUrl)
			return
		}
		error(t('add-to-wishlist-error'))
	}
	
}


const setupWishBtnsEvents = (wishlistP) => {
	wishlistP.addEventListener('click', addToWishlist)
}

const setupWishCardBtn = (buttons) => {
	buttons.forEach(item => {
		item.addEventListener('click', addToWishlist)
	})	
}

// init
if(wishlistP) {
	setupWishBtnsEvents(wishlistP)
}

if(wishlistC) {
	setupWishCardBtn(wishlistC)
}
